<div class="flex flex-col justify-start items-center h-full w-full max-h-full">
  <div
    class="flex mt-[5%] md:px-[4%] items-center justify-between w-full h-fit sm:flex-col md:flex-row"
  >
    <div
      class="flex flex-row gap-4 w-fit sm:order-2 md:order-1 sm:mt-4 lg:mt-unset"
    >
      <div
        class="dark:bg-none p-[2%] py-[2.2%] w-[7rem] dark:text-white rounded-3xl justify-center border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
        [ngClass]="{
          'bg-dark-accent-secondary': selectedType == faqType.faq
        }"
        (appClickableDirective)="updateSelectedType(faqType.faq)"
      >
        <span class="text-xs font-normal"> {{ "General Info" }}</span>
      </div>
      <div
        class="dark:bg-none p-[2.2%] w-[7rem] dark:text-white rounded-3xl justify-center border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
        [ngClass]="{
          'bg-dark-accent-secondary': selectedType == faqType.dos
        }"
        (appClickableDirective)="updateSelectedType(faqType.dos)"
      >
        <span class="text-xs font-normal"> {{ "Do's" }}</span>
      </div>
      <div
        class="dark:bg-none p-[2.2%] w-[7rem] dark:text-white rounded-3xl justify-center border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
        [ngClass]="{
          'bg-dark-accent-secondary': selectedType == faqType.dont
        }"
        (appClickableDirective)="updateSelectedType(faqType.dont)"
      >
        <span class="text-xs font-normal"> {{ "Don't" }}</span>
      </div>
    </div>
    <div
      class="relative lg:w-[27rem] md:w-[23rem] p-[2%] h-fit sm:order-1 md:order-2 sm:justify-center lg:justify-unset sm:w-[80%]"
    >
      <input
        id="searchbox"
        class="leading-10 w-full rounded-3xl border-[0.2px] border-neutral-50 bg-[#1d232b] text-white px-2"
        type="text"
        placeholder="Search"
        (keyup)="onSearchFilter(inputValue.value)"
        #inputValue
        required
      />

      <!-- Image on the right -->
      <img
        class="absolute top-[36%] lg:right-[10%] md:right-[10%] sm:right-[4%] transform -translate-y-1/2 w-6 h-6"
        src="../../../../assets/images/customer_screens/searchicon.svg"
        alt="search"
      />
    </div>
  </div>

  <div class="p-2 flex flex-grow overflow-hidden justify-center w-full">
    <div
      class="h-fit overflow-auto max-h-full flex flex-wrap questions sm:p-4 justify-center items-center
   sm:w-[80%]  md:w-[55%]  md:mr-12 lg:mr-0  lg:w-[44%]"
    >
      @if (selectedType == faqType.faq) {
        @for (item of faqData; track $index) {
          <div
            class="flex flex-col bg-[#444B58] p-5 rounded-[17px] items-start justify-center text-white  m-2 h-12 w-full
             max-h-fit
             "
            [ngClass]="{ expanded: item.expand }"
            (appClickableDirective)="toggleAnswer(item)"
          >
            <div class="flex flex-row justify-between w-full">
              <span class="text-wrap text-sm line-clamp-2">{{
                item.question
              }}</span>

@if(item.expand){
  <app-chevron-up-icon class="text-white" />
}@else {
    <app-chevron-down-icon class="text-white" />
}
              
            </div>
            @if(item.expand){
            <div  class="mt-2">
              <span class="text-wrap text-sm opacity-65">{{
                item.answer
              }}</span>
            </div>}
          </div>
        }
      } @else if (selectedType == faqType.dos) {
        @for (item of dosList; track $index) {
          <div
            class="flex flex-col bg-[#444B58] p-5 rounded-[17px] items-start justify-center text-wrap text-white max-h-fit
      w-full m-2 "
            [ngClass]="{ expanddoes: expanddoes }"
            (appClickableDirective)="toggleDos($index)"
          >
            <span class="text-wrap text-sm line-clamp-2">{{ item }}</span>
          </div>
        }
      } @else {
        @for (item of dontList; track $index) {
          <div
            class="flex flex-col bg-[#444B58] p-5 rounded-[17px]  w-full text-white text-wrap items-start justify-center  max-h-fit
             m-2 "
            [ngClass]="{ expanddont: expanddont }"
            (appClickableDirective)="toggleDont($index)"
          >
            <span class="text-wrap text-sm line-clamp-2">{{ item }}</span>
          </div>
        }
      }
    </div>
  </div>
</div>
